<template>
  <div class="summary">
    <div class="item">
      <div class="text evidence">
        {{
          getSettings.integralDivided
            ? $t('amount_total')
            : $t('amount_per_combination')
        }}
        {{ getSettings.currencySymbol }}
      </div>
      <div class="value">
        <input
          autocomplete="off"
          v-model.number="getBet._integral_detail.amount"
          type="number"
          step="0.50"
          @input="refreshCart()"
          @change="onChangeAmount(getBet._integral_detail.amount)"
        />
      </div>
    </div>

    <div
      class="item container_btn_add_amount"
      v-if="getSettings.enableButtonsCart"
    >
      <v-btn
        class="btn_add_amount_cart"
        px-1
        py-1
        v-for="(buttonCart, index) in getSettings.buttonsCart"
        :key="index"
        @click="addAmountBet(buttonCart.value)"
      >
        +{{ buttonCart.value }} {{ getSettings.currencySymbol }}
      </v-btn>
    </div>

    <div class="item" v-if="getSettings.in_combinations">
      <div class="text">
        {{ $t('amount_total') }}
      </div>

      <div class="value">
        {{ amountTotalComputed | round_digits(2) }}
      </div>

      <div class="sub-text">
        {{
          getSettings.integralDivided
            ? $t('total_equals_amount')
            : $t('total_equals_amount_x_combinations')
        }}
      </div>
    </div>

    <div class="item" v-if="getSettings.in_combinations">
      <div class="text">{{ $t('combinations') }}</div>
      <div class="value">{{ getBet._integral_detail.combinations }}</div>
    </div>

    <div class="item" v-if="getSettings.in_odds_total_min">
      <div class="text">{{ $t('odds') }} {{ $t('total') }} {{ $t('min') }}</div>
      <div class="value">
        x
        {{
          getBet._integral_detail.odds_total_min
            | round_digits(2)
            | odds_type_filter
        }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_odds_total_max">
      <div class="text">{{ $t('odds') }} {{ $t('total') }} {{ $t('max') }}</div>
      <div class="value">
        x
        {{
          getBet._integral_detail.odds_total_max
            | round_digits(2)
            | odds_type_filter
        }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_winning_min">
      <div class="text">{{ $t('winning') }} {{ $t('min') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.winning_min) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_winning_max">
      <div class="text">{{ $t('winning') }} {{ $t('max') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.winning_max) }}
      </div>
    </div>
    <div
      class="item"
      v-if="getSettings.in_bonus_min && +getBet._integral_detail.bonus_min > 0"
    >
      <div class="text">{{ $t('bonus') }} {{ $t('min') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.bonus_min) }}
      </div>
    </div>
    <div
      class="item"
      v-if="getSettings.in_bonus_max && +getBet._integral_detail.bonus_max > 0"
    >
      <div class="text">{{ $t('bonus') }} {{ $t('max') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.bonus_max) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_profit_min">
      <div class="text">{{ $t('profit') }} {{ $t('min') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.profit_min) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_profit_max">
      <div class="text">{{ $t('profit') }} {{ $t('max') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.profit_max) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_winning_total_min">
      <div class="text">
        {{ $t('winning') }} {{ $t('total') }} {{ $t('min') }}
      </div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.winning_total_min) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.in_winning_total_max">
      <div class="text">
        {{ $t('winning') }} {{ $t('total') }} {{ $t('max') }}
      </div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._integral_detail.winning_total_max) }}
      </div>
    </div>

    <template v-if="getPercentageTaxValueOnWon > 0">
      <div class="item">
        <div class="text">{{ $t('percentageTaxValueOnWon') }}</div>
        <div class="value">{{ getPercentageTaxValueOnWon + ' %' }}</div>
      </div>

      <div class="item">
        <div class="text">{{ $t('profit_min_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._integral_detail.profit_min_taxed) }}
        </div>
      </div>

      <div class="item">
        <div class="text">{{ $t('profit_max_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._integral_detail.profit_max_taxed) }}
        </div>
      </div>

      <div class="item">
        <div class="text">{{ $t('winning_total_min_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._integral_detail.winning_total_min_taxed) }}
        </div>
      </div>

      <div class="item">
        <div class="text">{{ $t('winning_total_max_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._integral_detail.winning_total_max_taxed) }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SummaryIntegral',
  data: () => ({}),
  async mounted() {
    this.restoreLastAmount();
    this.$root.$on('forceUpdateIntegral', () => {
      this.forceUpdateSummaryIntegral();
    });
  },
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
      getPercentageTaxValueOnWon: 'settings/getPercentageTaxValueOnWon'
    }),

    amountTotalComputed() {
      const amount = +this.getBet._integral_detail.amount || 0;
      const combinations = +this.getBet._integral_detail.combinations || 1;

      return this.getSettings.integralDivided ? amount : amount * combinations;
    }
  },
  methods: {
    ...mapActions({
      refreshCart: 'cart/refreshCart'
    }),

    forceUpdateSummaryIntegral() {
      this.$forceUpdate();
    },
    addAmountBet(amount) {
      if (amount != undefined && +amount > 0.0) {
        this.getBet._integral_detail.amount += +amount;
        this.onChangeAmount(+this.getBet._integral_detail.amount);
        this.refreshCart();
      }
    },
    onChangeAmount(val) {
      this.$store.dispatch('cart/setLastSelectedAmount', val);
    },

    formatNumber(amount) {
      let numberFormatted = new Intl.NumberFormat().format(amount);
      return numberFormatted;
    },
    async restoreLastAmount() {
      const lastAmount = this.$store.getters['cart/getLastSelectedAmount'];
      if (
        lastAmount !== null &&
        lastAmount !== undefined &&
        lastAmount !== this.getBet._integral_detail.amount
      ) {
        this.$store.commit('cart/SET_INTEGRAL_AMOUNT', +lastAmount);
        await this.refreshCart();
      }
    }
  }
};
</script>

<style scoped>
.item {
  display: flex;
  flex-wrap: wrap;
}

.sub-text {
  flex-basis: 100%;
  font-size: 12px;
  opacity: 0.7;
  margin-top: 4px;
  line-height: 1.3;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
